// NEW: UI_REVAMP
import { useMediaQuery } from '@chakra-ui/react';

export const MOBILE_VIEW_MEDIA_QUERY = '(max-width: 1023px)';

const useIsMobileView = () => {
	const [isMobileView] = useMediaQuery(MOBILE_VIEW_MEDIA_QUERY);

	return isMobileView;
};

export default useIsMobileView;
